import type { MenuProps } from '@mui/material';
import type { Theme, SxProps } from '@mui/material/styles';

export const SELECT_MENU_PROPS: Partial<MenuProps> = {
  PaperProps: {
    sx: {
      borderRadius: 1,
      minWidth: 250,
      overflow: 'hidden',
      boxShadow: (theme: Theme) => theme.card.shadow,
    },
  },
  MenuListProps: {
    sx: {
      py: 0,
      '& .MuiMenuItem-root': {
        py: 1.25,
        minHeight: 44,
        fontSize: 14,
        color: 'text.primary',
        justifyContent: 'flex-start',
        textAlign: 'left',
      },
      '& .MuiMenuItem-root:hover': {
        bgcolor: 'action.hover',
      },
      '& .MuiMenuItem-root.Mui-selected': {
        bgcolor: 'action.selected',
        color: 'text.primary',
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        bgcolor: 'action.selected',
      },
    },
  },
};
export const SELECT_MENU_ITEM_SX: SxProps<Theme> = { py: 1.25, minHeight: 44, fontSize: 14 };
